module.exports = __webpack_public_path__ + "static/media/24.fff26b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/24.jpg
// module id = 185
// module chunks = 0